module.exports = __webpack_public_path__ + "img/app5.cb40afce.png";